<div class="generalPage" aria-label="help goto" role="main">
  <div class="pr-22 content-container pb-0 print-all-content" [ngClass]="IsRightPanel?'pt-0':''">
    <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont pb-heading" role="heading">{{goto_heading}}</h1>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="goto_desc"></p>
    <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{goto_para1heading}}</p>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="goto_para1body"></p>
    <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{goto_para2heading}}</p>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="goto_para2_body"></p>
  </div>
</div>

